exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addfirware[data-v-01ca1e75]{padding-top:20px;padding-right:20px}.addfirware .btn[data-v-01ca1e75]{width:100%;text-align:center}\n", ""]);

// exports
